import { useState } from "react";
import { Header } from "@/components/layout/Header";
import { CreditCostForm } from "@/components/admin/CreditCostForm";
import { Tabs, TabsContent, TabsList, TabsTrigger } from "@/components/ui/tabs";
import { useAuth } from "@/contexts/AuthContext";
import { Navigate } from "react-router-dom";
import { Card, CardContent } from "@/components/ui/card";
import { Button } from "@/components/ui/button";
import { toast } from "@/components/ui/sonner";
import CreditPackAdmin from "@/components/admin/CreditPackAdmin";

const Admin = () => {
  const { isAdmin } = useAuth();
  const [activeTab, setActiveTab] = useState("credit-costs");

  // Redirect non-admin users
  if (!isAdmin) {
    return <Navigate to="/" />;
  }

  const handleTestService = () => {
    toast.success("Test service initiated successfully!");
  };

  return (
    <div className="min-h-screen flex flex-col">
      <Header />
      <main className="flex-1 container py-8">
        <h1 className="text-3xl font-bold mb-6">Admin Panel</h1>
        
        <Tabs value={activeTab} onValueChange={setActiveTab} className="w-full">
          <TabsList className="mb-6">
            <TabsTrigger value="credit-costs">Credit Costs</TabsTrigger>
            <TabsTrigger value="credit-packs">Credit Packs</TabsTrigger>
            <TabsTrigger value="test-services">Test Services</TabsTrigger>
            <TabsTrigger value="users">User Management</TabsTrigger>
          </TabsList>
          
          <TabsContent value="credit-costs">
            <CreditCostForm />
          </TabsContent>
          
          <TabsContent value="credit-packs">
            <CreditPackAdmin />
          </TabsContent>
          
          <TabsContent value="test-services">
            <Card>
              <CardContent className="pt-6 space-y-6">
                <div>
                  <h2 className="text-xl font-semibold mb-2">Virtual Staging Test</h2>
                  <p className="text-gray-500 mb-4">
                    Test the virtual staging service without consuming credits
                  </p>
                  <Button onClick={handleTestService}>Run Test</Button>
                </div>
                
                <div className="border-t pt-6">
                  <h2 className="text-xl font-semibold mb-2">API Status</h2>
                  <div className="flex items-center">
                    <div className="h-3 w-3 rounded-full bg-green-500 mr-2"></div>
                    <p>Staging API: Online</p>
                  </div>
                </div>
              </CardContent>
            </Card>
          </TabsContent>
          
          <TabsContent value="users">
            <Card>
              <CardContent className="pt-6">
                <p className="text-gray-500">
                  User management functionality will be implemented with Supabase integration.
                </p>
              </CardContent>
            </Card>
          </TabsContent>
        </Tabs>
      </main>
    </div>
  );
};

export default Admin;
